import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg'

export default DeleteIcon
